import { defineStore } from 'pinia';
import apiClient from '@/api/index';
import type { AppSettings } from '@/types/settings';

export interface SettingsState {
    settings: AppSettings | null;
    loading: boolean;
    error: string | null;
    isSaving: boolean;
    organizations: any[]
    organization: {
        id: number | null;
        name: string;
        inn: string;
        legal_address: string | null;
        product_group: string | null;
        country: string | null;
        business_place_id: string | null;
        asl_belgisi_config: {
            login: string | null | undefined;
            password: string | null | undefined;
            token: string | null | undefined;
        },
        is_asl_belgisi_working: boolean
        is_didox_working: boolean
    };
    preferences: any | null;
    templateTypes: any[];
}

export const useSettingsStore = defineStore('settings', {
    state: (): SettingsState => ({
        settings: null,
        organizations: [],
        loading: false,
        error: null,
        isSaving: false,
        organization: {
            id: null,
            name: '',
            inn: '',
            legal_address: '',
            product_group: null,
            country: null,
            business_place_id: null,
            asl_belgisi_config: {
                login: null,
                password: null,
                token: null,
            },
            is_asl_belgisi_working: false,
            is_didox_working: false
        },
        preferences: null,
        templateTypes: [],
    }),

    actions: {
        async fetchSettings() {
            this.loading = true;
            this.error = null;
            try {
                const response = await apiClient.get(`/organization/`);
                this.organization = response.data;
            } catch (err) {
                this.error = 'Ошибка при загрузке настроек.';
                console.error(err);
                throw err;
            } finally {
                this.loading = false;
            }
        },

        async updateSettings(settingsData: any, preferences: any) {
            this.isSaving = true;
            this.error = null;
            try {
                const response = await apiClient.patch(`/organization/`, settingsData);
                this.settings = response.data;
                const prefResponse = await apiClient.post(`/notifications/preferences/bulk_update/`, { preferences });
                this.preferences = prefResponse.data;
            } catch (err: any) {
                this.error = err.response?.data?.detail || 'Ошибка при сохранении настроек.';
                console.error(err);
                throw err;
                throw err;
            } finally {
                this.isSaving = false;
            }
        },

        async fetchPreferences() {
            this.loading = true;
            this.error = null;
            try {
                const response = await apiClient.get(`/notifications/preferences/`);
                this.preferences = response.data.results;
            } catch (err) {
                this.error = 'Ошибка при загрузке предпочтений.';
                console.error(err);
                throw err;
            } finally {
                this.loading = false;
            }
        },

        async fetchTemplateTypes() {
            this.loading = true;
            this.error = null;
            try {
                const response = await apiClient.get(`/notifications/notifications/template_types/`);
                this.templateTypes = response.data.template_types;
            } catch (err) {
                this.error = 'Ошибка при загрузке типов шаблонов.';
                console.error(err);
                throw err;
            } finally {
                this.loading = false;
            }
        }
    },
});